import { useHistory } from "react-router-dom";
import { openNewWindow } from "../../../utils/common";
import { useState } from "react";
import { OpenChatLabels } from "../../../utils/constants";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
import {
  EventWrapper,
  ContentWrapper,
  JaeJooDoWrapper,
  KyungKiDoWrapper,
  InChonWrapper,
  SeoulWrapper,
  KangWonDoWrapper,
  JunRaDoWrapper,
  BuSanWrapper,
  DaeGuWrapper,
  ChwoongChungDoWrapper,
  DaeJoenWrapper,
  OpenChatSelectWrapper,
  OpenChatTitleWrapper,
  SelectorWrapper,
} from "./style";
import OpenChatPubList from "./components/franchis-list";
import { Overlay } from "../OddsCalc/styles";

export interface OpenChatDto {
  textColor: string;
  backgroundColor: string;
  label: string;
  image: string;
  url: string;
}
const OpenChatList = () => {
  const history = useHistory();
  const inset = useRecoilValue(insetState);
  const [openList, setOpenList] = useState<boolean>(false);
  const [openChatLabel, setOpenChatLabel] = useState(OpenChatLabels[0]);

  return (
    <EventWrapper scrollLock={false} isApp={inset}>
      <div className="header">
        <div
          className="close"
          onClick={() => {
            history.push("/");
          }}
        >
          <img
            src="/image-web/Icon/Back.svg"
            id="오픈톡 뒤로가기"
            alt="close"
          />
        </div>
        <div className="title">지역별 오픈채팅</div>
      </div>
      <ContentWrapper>
        <div className="map" id="맵 이미지">
          <JaeJooDoWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[9]);
              setOpenList(true);
            }}
          ></JaeJooDoWrapper>
          <KyungKiDoWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[1]);
              setOpenList(true);
            }}
          ></KyungKiDoWrapper>
          <InChonWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[2]);
              setOpenList(true);
            }}
          ></InChonWrapper>
          <SeoulWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[0]);
              setOpenList(true);
            }}
          ></SeoulWrapper>
          <KangWonDoWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[3]);
              setOpenList(true);
            }}
          ></KangWonDoWrapper>
          <JunRaDoWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[4]);
              setOpenList(true);
            }}
          ></JunRaDoWrapper>
          <BuSanWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[5]);
              setOpenList(true);
            }}
          ></BuSanWrapper>
          <DaeGuWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[6]);
              setOpenList(true);
            }}
          ></DaeGuWrapper>
          <ChwoongChungDoWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[7]);
              setOpenList(true);
            }}
          ></ChwoongChungDoWrapper>
          <DaeJoenWrapper
            onClick={() => {
              setOpenChatLabel(OpenChatLabels[8]);
              setOpenList(true);
            }}
          ></DaeJoenWrapper>
          <img src={openChatLabel.image} alt="맵이미지" />
          <div
            className="runner-open-button"
            id="입장버튼"
            onClick={() => {
              openNewWindow("https://open.kakao.com/o/gCoBPh4f");
            }}
          >
            러너러너 공식 오픈채팅
          </div>
        </div>

        <OpenChatSelectWrapper>
          <OpenChatTitleWrapper>
            실시간 지역별
            <br />
            홀덤펍/토너먼트 대회정보를 확인해보세요!
          </OpenChatTitleWrapper>
          <SelectorWrapper>
            {OpenChatLabels.map((item, i) => {
              return (
                <div
                  style={{
                    color: openChatLabel === item ? item.textColor : "#d9d9d9",
                    backgroundColor:
                      openChatLabel === item ? item.backgroundColor : "white",
                  }}
                  className={
                    "location " + (openChatLabel === item ? "selected" : "")
                  }
                  key={i}
                  onClick={() => {
                    setOpenChatLabel(item);
                    setOpenList(true);
                  }}
                >
                  {item.label}
                </div>
              );
            })}
          </SelectorWrapper>
        </OpenChatSelectWrapper>
      </ContentWrapper>
      {openList && (
        <>
          <OpenChatPubList
            onClose={() => setOpenList(false)}
            openChatLabel={openChatLabel}
          />
          <Overlay />
        </>
      )}
    </EventWrapper>
  );
};

export default OpenChatList;
